var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable modal-xl" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Browse logs"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("div", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading..."),
                      ])
                    : _c(
                        "div",
                        [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-sm-6" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.searchLogEntriesPhrase,
                                    expression: "searchLogEntriesPhrase",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "search",
                                  placeholder: "Search log...",
                                },
                                domProps: { value: _vm.searchLogEntriesPhrase },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.searchLogEntriesPhrase =
                                      $event.target.value
                                  },
                                },
                              }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-sm-6" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.logEntriesTitle,
                                      expression: "logEntriesTitle",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  on: {
                                    change: function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.logEntriesTitle = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                  },
                                },
                                [
                                  _c("option", { domProps: { value: null } }, [
                                    _vm._v("All"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Note added" } },
                                    [_vm._v("Notes")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Email sent" } },
                                    [_vm._v("Emails")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Dependency added" } },
                                    [_vm._v("Dependencies")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    { attrs: { value: "Document added" } },
                                    [_vm._v("Documents")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.logEntriesView, function (e) {
                            return _c(
                              "div",
                              { key: e.Id, staticClass: "row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-sm-2 col-lg-2" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          margin: "15px",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _c("span", {
                                          staticClass: "fg-color-gray2 small",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.getHumanizedTimeSince(
                                                e.Created
                                              )
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("br"),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "fg-color-gray2 small",
                                          },
                                          [_vm._v("ago")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-sm-10 col-lg-10" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "dashboard-box clearfix",
                                        staticStyle: { padding: "15px 30px" },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pull-left",
                                            staticStyle: { width: "50px" },
                                          },
                                          [
                                            _c("span", {
                                              class: [
                                                "fg-color-gray2",
                                                "glyphicon",
                                                "glyphicon-" + e.Icon,
                                              ],
                                              staticStyle: {
                                                "font-size": "24px",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pull-left",
                                            staticStyle: {
                                              width: "calc(100% - 50px)",
                                            },
                                          },
                                          [
                                            _c("strong", [
                                              _vm._v(_vm._s(e.Title)),
                                            ]),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "small fg-color-gray1",
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        e.Created,
                                                        "MMM Do, YYYY [at] hh:mm a"
                                                      )
                                                    ) +
                                                    " by " +
                                                    _vm._s(e.Person) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("p", {
                                              staticClass: "log-content",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.marked(e.Description)
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            e.Changes && e.Changes.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "overflow-x": "hidden",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "table",
                                                      {
                                                        staticClass:
                                                          "table table-striped",
                                                      },
                                                      [
                                                        _vm._m(0, true),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          e.Changes,
                                                          function (ch) {
                                                            return _c("tbody", [
                                                              _c("tr", [
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      ch.Property
                                                                    )
                                                                  ),
                                                                ]),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "overflow-x":
                                                                          "hidden",
                                                                      },
                                                                  },
                                                                  [
                                                                    ch.PrevValue
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.marked(
                                                                                      ch.PrevValue
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    !ch.PrevValue
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-question-circle fg-color-gray",
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "overflow-x":
                                                                          "hidden",
                                                                      },
                                                                  },
                                                                  [
                                                                    ch.CurrValue
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            domProps:
                                                                              {
                                                                                innerHTML:
                                                                                  _vm._s(
                                                                                    _vm.marked(
                                                                                      ch.CurrValue
                                                                                    )
                                                                                  ),
                                                                              },
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    !ch.CurrValue
                                                                      ? _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "fa fa-question-circle fg-color-gray",
                                                                          }
                                                                        )
                                                                      : _vm._e(),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ])
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Before")]),
        _vm._v(" "),
        _c("th", [_vm._v("After")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }